export enum Notation {
  Auto = 'Auto',
  Scientific = 'Scientific',
  FixedPoint = 'Fixed-point',
}
